import React from 'react';
import { View, Text, StyleProp, TextStyle } from 'react-native';

import ColorWrapper from '@styles/colors';
import TouchableElement from '@components/common/touchableElement';
import { SmallLoading } from '@components/loading';

import { ColorFunction } from '@styles/colors/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { font } from '@styles/fonts';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

interface FilterButtonProps {
  C: ColorFunction;
  scale: ScaleFunction;
  font: typeof font;
  selected?: boolean;
  count?: number;
  title: string;
  onClick: () => void;
  loading: boolean;
}

const FilterButton: React.FC<FilterButtonProps> = ({ C, scale, font, title, count, selected, onClick, loading }) => {
  return (
    <TouchableElement disabled={loading} onPress={onClick}>
      {({ boxStyle, hovered, pressed }) => {
        const isHoverStyle = hovered && !pressed && !loading;

        const textStyles: StyleProp<TextStyle> = [
          font['Subhead 1'],
          { textAlign: 'center', fontWeight: 400 },
          selected
            ? { color: C(loading ? 'Label/Light/Always Light Tertiary' : 'Button/Light/Primary Text') }
            : { color: C(isHoverStyle ? 'Label/Light/Primary' : 'Label/Light/Unselected') },
        ];

        return (
          <View
            style={[
              boxStyle,
              // @ts-ignore
              {
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                flex: '0.5 1 100%',
                paddingVertical: scale(4),
                paddingHorizontal: scale(28),
                borderRadius: scale(SCREEN_BORDER_RADIUS),
              },
              selected
                ? { backgroundColor: C(loading ? 'Button/Light/Primary pressed' : 'Selected/Light/Primary') }
                : { backgroundColor: C(isHoverStyle ? 'Button/Light/Only Text hover' : 'Gray/Light/5') },
            ]}
          >
            <Text style={textStyles}>{count?.toLocaleString('de-DE')}</Text>
            <Text style={textStyles}>{title}</Text>
            {selected && loading ? (
              <View
                style={{
                  position: 'absolute',
                  inset: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <SmallLoading color={C('Label/Light/AlwaysLight Secondary')} />
              </View>
            ) : null}
          </View>
        );
      }}
    </TouchableElement>
  );
};

export default ColorWrapper(FilterButton);
